import { Tabs } from "@mui/base/Tabs";
import { TabsList } from "@mui/base/TabsList";
import { TabPanel } from "@mui/base/TabPanel";
import { Tab } from "@mui/base/Tab";
import PersonalInfo from "../Components/Kyc/PersonalInfo";
import AdminKyc from "../Components/Kyc/AdminKyc";
import { useUserInfoQuery, useApproveKycMutation, useRejectKycMutation } from "../redux/features/user/userApi";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Security from "../Components/Kyc/Security";
import Navbar from "../Components/Navbar";
import { toast } from "react-toastify";
import { hasPermission, canRead, canWrite, getPermissionLevel, isAdmin } from "../utils/permissionUtils";
import Unauthorized from "./Unauthorized";
import StakeHistory from "../Components/Kyc/StakeHistory";
import Wallet from "../Components/Kyc/Wallet";
import TranctionH from "../Components/Kyc/TranctionH";
import SubscribeU from "../Components/Kyc/SubscribeU";
import SubsHis from "../Components/Kyc/SubHistory";
import CustomModel from "../Components/CustomModel";
import PortfolioU from "../Components/Kyc/PortfolioU";
const Kyc = () => {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [rejectDialogOpen, setRejectDialogOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);
  const [updatedStatus, setUpdatedStatus] = useState(null);

  const handleImageViewer = (type) => {

    <CustomModel img={type} setOpen={setOpen} open={open} />
  }

  const canReadUserDetails = canRead('user_details');
  const canWriteUserDetails = canWrite('user_details');



  const { id } = useParams();

  console.log(`fgfg ${id}`);
  // const [reason, setReason]=useState(["test"]);  
  const [data, setData] = useState([]);

  const { data: userData, isSuccess, refetch } = useUserInfoQuery(id);
  // console.log(`userdata ${JSON.stringify(userData)}`);
  const [approveKyc, { isSuccess: approveSuccess, isError: approveError, data: approveData }] = useApproveKycMutation({});
  const [rejectKyc, { isSuccess: rejectSuccess, isError: rejectError, data: rejectData }] = useRejectKycMutation()



  const handleApprove = async (page) => {
    if (isProcessing) return;

    const userConfirmed = window.confirm('Are you sure you want to approve this KYC?');

    if (userConfirmed) {
      setIsProcessing(true);
      try {
        const result = await approveKyc({ id, page }).unwrap();
        if (result.status === true) {
          // Set the updated status before showing success message
          setUpdatedStatus({
            page: page,
            status: 1, // 1 for approved
            verifiedBy: localStorage.getItem('username') || 'Admin'
          });
          toast.success(result.message || "KYC document approved successfully");

          // Force refetch the data
          try {
            const refetchResult = await refetch();
            if (refetchResult.data) {
              setData(refetchResult.data.data);
            }
          } catch (refetchError) {
            console.error("Error refetching data:", refetchError);
          }
        } else {
          toast.error(result.message || "Failed to approve KYC document");
          // Revert the status update if API call fails
          setUpdatedStatus(null);
        }
        return result; // Return the result for the child component to handle
      } catch (error) {
        toast.error(error?.data?.message || "Failed to approve KYC document");
        // Revert the status update if API call fails
        setUpdatedStatus(null);
        throw error; // Re-throw the error for the child component to handle
      } finally {
        setIsProcessing(false);
      }
    } else {
      toast.error("Failed to approve KYC document");
      setIsProcessing(false);
    }
  };

  const handleReject = (page) => {
    setCurrentPage(page);
    setReason(""); // Reset reason when opening dialog
    setRejectDialogOpen(true);
  };

  const handleRejectConfirm = async () => {
    if (isProcessing) return;

    if (!reason.trim()) {
      toast.error("Please provide a reason for rejection");
      return;
    }


    const userConfirmed = window.confirm('Are you sure you want to reject this KYC?');

    if (userConfirmed) {
      setIsProcessing(true);
      try {
        const result = await rejectKyc({
          id,
          page: currentPage,
          reason: reason.trim()
        }).unwrap();

        if (result.status === true) {
          // Set the updated status before closing dialog
          setUpdatedStatus({
            page: currentPage,
            status: 0, // 0 for rejected
            verifiedBy: null // Clear verified by on rejection
          });

          toast.success(result.message || "KYC document rejected successfully");
          setRejectDialogOpen(false);
          setReason("");

          // Force refetch the data
          try {
            const refetchResult = await refetch();
            if (refetchResult.data) {
              setData(refetchResult.data.data);
            }
          } catch (refetchError) {
            console.error("Error refetching data:", refetchError);
          }
        } else {
          toast.error(result.message || "Failed to reject KYC document");
          // Revert the status update if API call fails
          setUpdatedStatus(null);
        }
      } catch (error) {
        toast.error(error?.data?.message || "Failed to reject KYC document");
        // Revert the status update if API call fails
        setUpdatedStatus(null);
      } finally {
        setIsProcessing(false);
      }
    } else {
      toast.error("Failed to reject KYC document");
      setIsProcessing(false);
    }

  };

  const tab = [
    "Personal Info",
    "Security",
    "Wallet",
    "Subscribe History",
    "SIP History",
    "Transaction History",
    "Portfolio",
    // "Ticket",
  ];


  console.log("kyc rendered");
  useEffect(() => {
    if (isSuccess) {
      setData(userData.data);
    }
  }, [setData, isSuccess]);
  console.log(`hjkjk ${data}`);
  return (
    <>
      <Navbar className="fixed top-0 left-0 w-full z-50" />
      {canReadUserDetails ?

        <div className="pt-[64px]"> {/* Add padding to prevent content from being hidden behind the fixed navbar */}
          {/* Permission Indicator Header */}
          <div className="bg-gradient-to-r from-blue-900 to-indigo-900 text-white p-4 mb-0 shadow-lg">
            <div className="max-w-7xl mx-auto flex items-center justify-between">
              <div className="flex items-center gap-3">
                <h1 className="text-2xl font-bold">User Details - KYC Management</h1>
                <div className="flex items-center gap-2">
                  
                </div>
              </div>
              <div className="text-sm text-blue-200">
                User ID: {id}
              </div>
            </div>
          </div>

          <Tabs defaultValue={0}>
            <TabsList className="w-full bg-blue-950 flex font-sans items-center justify-center content-between min-w-tabs-list flex-wrap md:flex-nowrap shadow-lg">
              {tab.map((item, index) => {
                return (
                  <Tab
                    slotProps={{
                      root: ({ selected, disabled }) => ({
                        className: `font-sans   ${selected
                          ? "text-blue-950 bg-white"
                          : "text-white bg-transparent focus:text-white hover:bg-blue-900"
                          } ${disabled
                            ? "cursor-not-allowed opacity-50"
                            : "cursor-pointer"
                          } text-sm font-bold w-full p-2 m-1.5 border-0 rounded-md flex justify-center focus:outline-0 focus:shadow-outline-blue-light`,
                      }),
                    }}
                    value={index}
                    key={index}
                  >
                    {item}
                  </Tab>
                );
              })}
            </TabsList>

            <TabPanel className="w-full font-sans text-sm" value={0}>
              <PersonalInfo
                id={id}
                data={data}
                handleApprove={handleApprove}
                handleReject={handleReject}
                isProcessing={isProcessing}
                rejectDialogOpen={rejectDialogOpen}
                setRejectDialogOpen={setRejectDialogOpen}
                reason={reason}
                setReason={setReason}
                handleRejectConfirm={handleRejectConfirm}
                setOpen={setOpen}
                open={open}
                handleImageViewer={handleImageViewer}
                updatedStatus={updatedStatus}
                setUpdatedStatus={setUpdatedStatus}
                canWrite={canWriteUserDetails}
              />
            </TabPanel>
            <TabPanel className="w-[80vw] m-auto font-sans text-sm" value={1}>
              <Security id={id} data={data} canWrite={canWriteUserDetails} />

            </TabPanel>
            <TabPanel className="w-[80vw] m-auto font-sans text-sm" value={2}>
              <Wallet id={id} wallet={userData?.wallet || []} />
            </TabPanel>
             <TabPanel className="w-[80vw] m-auto font-sans text-sm" value={3}>
              <SubscribeU id={id} />
            </TabPanel>
            <TabPanel className="w-[80vw] m-auto font-sans text-sm" value={4}>
              <SubsHis id={id} />
            </TabPanel>
            <TabPanel className="w-[80vw] m-auto font-sans text-sm" value={5}>
              <TranctionH
                id={id}
                transactions={userData?.transcations || []}
                isLoading={!isSuccess}
              />
            </TabPanel>
            <TabPanel className="w-[80vw] m-auto font-sans text-sm" value={6}>
              <PortfolioU id={id} />
            </TabPanel>
          </Tabs>
        </div>

        :
        <Unauthorized />
      }

      {/* Reject Dialog */}
      {rejectDialogOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg w-96">
            <h3 className="text-lg font-bold mb-4">Reject KYC Document</h3>
            <textarea
              className="w-full p-2 border rounded mb-4"
              placeholder="Enter reason for rejection"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows="4"
              disabled={isProcessing}
            />
            <div className="flex justify-end gap-4">
              <button
                className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
                onClick={() => {
                  setRejectDialogOpen(false);
                  setReason("");
                }}
                disabled={isProcessing}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-red-500 text-white rounded disabled:opacity-50"
                onClick={handleRejectConfirm}
                disabled={isProcessing}
              >
                {isProcessing ? "Processing..." : "Confirm Reject"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Kyc;
